"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _JNPWebServiceAppBar = _interopRequireWildcard(require("./JNPWebServiceAppBar"));

var _myHistory = require("./myHistory");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _appStyles = require("./styles/app-styles");

var _splash = _interopRequireDefault(require("./splash.png"));

var _reactRedux = require("react-redux");

var _utilities = require("./utilities");

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var appScope = process.env.REACT_APP_SCOPE;
var LOGOUT_URL = process.env.REACT_APP_TOKEN_LOGOUT;

var AuthProviderContent = function AuthProviderContent(props) {
  var classes = (0, _appStyles.useStyles)();
  var token = props.token,
      _props$showUtilityBar = props.showUtilityBar,
      showUtilityBar = _props$showUtilityBar === void 0 ? true : _props$showUtilityBar,
      _props$useSecurity = props.useSecurity,
      useSecurity = _props$useSecurity === void 0 ? true : _props$useSecurity;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLogguedIn = _useState2[0],
      setIsLogguedIn = _useState2[1];

  var _useState3 = (0, _react.useState)({
    username: '',
    availableLinks: [],
    helpGuidesForLinks: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      userInfo = _useState4[0],
      setUserInfo = _useState4[1];

  (0, _react.useEffect)(function () {
    var isTokenValid = function isTokenValid(token) {
      var isTokenNotNull = token && token !== null && token !== "undefined" && token !== "null";

      if (isTokenNotNull) {
        var _decodedToken$authori;

        var decodedToken = (0, _jwtDecode.default)(token);
        var isScopeValid = decodedToken === null || decodedToken === void 0 ? void 0 : (_decodedToken$authori = decodedToken.authorities) === null || _decodedToken$authori === void 0 ? void 0 : _decodedToken$authori.some(function (x) {
          return x === appScope;
        });

        if (!isScopeValid) {
          localStorage.setItem('TOKEN', null);
          window.location.assign(LOGOUT_URL);
        }

        return !useSecurity || isScopeValid && !(0, _utilities.isLogin)();
      }

      return !useSecurity || !(0, _utilities.isLogin)() && isTokenNotNull;
    };

    var tokenValid = isTokenValid(token);
    setIsLogguedIn(tokenValid);

    if (tokenValid) {
      loadPrincipal();
    }
  }, [token]);

  function loadPrincipal() {
    return _loadPrincipal.apply(this, arguments);
  }

  function _loadPrincipal() {
    _loadPrincipal = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _JNPWebServiceAppBar.axiosInstance.get(process.env.REACT_APP_RESOURCE_SERVER_BASE_URL + '/me').then(function (response) {
                return response.data;
              }).then(function (data) {
                return setUserInfo(data);
              }).catch(function (error) {
                return console.log(error);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _loadPrincipal.apply(this, arguments);
  }

  var content = isLogguedIn ? (0, _utilities.createChildrenWithProps)(props.children, userInfo) : /*#__PURE__*/_react.default.createElement(DashboardMain, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "App"
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), useSecurity && /*#__PURE__*/_react.default.createElement(_JNPWebServiceAppBar.default, {
    showUtilityBar: showUtilityBar,
    userInfo: userInfo
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, {
    history: _myHistory.history
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("main", {
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.toolbar
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/login-unauthorized"
  }, /*#__PURE__*/_react.default.createElement(DashboardMain, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/"
  }, content))))));
};

function DashboardMain() {
  var classes = (0, _appStyles.useStyles)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.splashContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _splash.default,
    alt: "Splash Logo",
    className: classes.splash
  }));
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    token: state.loginReducer.token
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AuthProviderContent);

exports.default = _default;